import { useId } from 'react';

import { fontStyles } from '@/styles/typography';

import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

function ChildRowBridgedBadgeBody({ describedBy }: { describedBy?: string }) {
  return (
    <div
      aria-describedby={describedBy}
      className="bg-token-gray-200 border-token-gray-500 text-token-gray-800 flex h-[18px] shrink-0 cursor-default items-center justify-center rounded-[26px] border border-solid px-[5px] py-px"
    >
      <span
        className={fontStyles({
          variant: 'LABEL_XS',
          class: 'text-token-gray-800 before:content-none after:content-none',
        })}
      >
        Bridged
      </span>
    </div>
  );
}

/**
 * Compact bridged badge for grouped child rows in the homepage discovery table.
 */
export function ChildRowBridgedBadge() {
  const randomId = useId();
  const tooltipId = `${randomId}-bridged-help-text`;

  return (
    <MatchaTooltip>
      <MatchaTooltipTrigger>
        <span className="inline-flex shrink-0">
          <ChildRowBridgedBadgeBody describedBy={`${randomId}-bridged-help-text`} />
        </span>
      </MatchaTooltipTrigger>
      <MatchaTooltipContent>
        <span id={tooltipId}>
          Bridged token represents an asset locked on its original network.
        </span>
      </MatchaTooltipContent>
      <MatchaTooltipPopover
        sideOffset={8}
        className="max-w-[246px] inline-block tablet:text-center"
      />
      <MatchaTooltipBottomSheet header="Bridged" />
    </MatchaTooltip>
  );
}
